"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbpPromotionsMapper = void 0;
var Utils = require("../../utils/UtilityFunctions");
var AbpPromotionsMapper = /** @class */ (function () {
    function AbpPromotionsMapper(data) {
        var _this = this;
        this.formatPlanProductIDs = function (item, planProductIDs) {
            var _a;
            var itemType = (_a = item === null || item === void 0 ? void 0 : item.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase();
            if (planProductIDs &&
                ('SHAREDDATAGROUP|SHAREDDATAFEATURE|VOICEPLAN').includes(itemType) && (item === null || item === void 0 ? void 0 : item.id)) {
                var isSkip_1 = false;
                (item === null || item === void 0 ? void 0 : item.productCode) && (planProductIDs === null || planProductIDs === void 0 ? void 0 : planProductIDs.forEach(function (pPID) {
                    if (pPID === (item === null || item === void 0 ? void 0 : item.productCode)) {
                        isSkip_1 = true;
                    }
                }));
                if (!isSkip_1) {
                    return item === null || item === void 0 ? void 0 : item.productCode;
                }
            }
        };
        this.filterCharacteristics = function (promoProductChars, charName) {
            var charValue;
            promoProductChars === null || promoProductChars === void 0 ? void 0 : promoProductChars.filter(function (char) {
                var _a;
                if (((_a = char === null || char === void 0 ? void 0 : char.name) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === (charName === null || charName === void 0 ? void 0 : charName.toLocaleLowerCase())) {
                    charValue = char === null || char === void 0 ? void 0 : char.value;
                }
            });
            return charValue;
        };
        this.isProductIDAvailable = function (qualifyingsdfproductcodes, cartProducts) {
            var isAvailable = false;
            if (!qualifyingsdfproductcodes || !cartProducts) {
                return isAvailable;
            }
            cartProducts.forEach(function (product) {
                if (qualifyingsdfproductcodes === null || qualifyingsdfproductcodes === void 0 ? void 0 : qualifyingsdfproductcodes.includes(product)) {
                    isAvailable = true;
                }
            });
            return isAvailable;
        };
        this.stringToNumber = function (str) {
            var num = parseFloat(str);
            if (Number.isInteger(num)) {
                return num;
            }
            else {
                return num.toString().replace(/\.00$/, '');
            }
        };
        this.getABPPromotionsWithTenderTypes = function (planProductIDs, abpPromos) {
            var abpPromotions = {
                ach: {
                    amount: 0,
                    id: '',
                    name: '',
                },
                debitcard: {
                    amount: 0,
                    id: '',
                    name: '',
                },
                citicard: {
                    amount: 0,
                    id: '',
                    name: '',
                },
                creditcard: {
                    amount: 0,
                    id: '',
                    name: '',
                },
            };
            if (planProductIDs && abpPromos) {
                abpPromos.forEach(function (promo) {
                    var _tenderTypes = _this.filterCharacteristics(promo === null || promo === void 0 ? void 0 : promo.promotionCharacteristics, 'tenderTypes');
                    var _qProductCodes = _this.filterCharacteristics(promo === null || promo === void 0 ? void 0 : promo.promotionCharacteristics, 'qualifyingSDFproductCodes');
                    var _providerTypes = _this.filterCharacteristics(promo === null || promo === void 0 ? void 0 : promo.promotionCharacteristics, 'providerTypes');
                    var amount = _this.filterCharacteristics(promo === null || promo === void 0 ? void 0 : promo.promotionCharacteristics, 'amount');
                    var promotionCode = _this.filterCharacteristics(promo === null || promo === void 0 ? void 0 : promo.promotionCharacteristics, 'promotionCode');
                    if (_this.isProductIDAvailable(_qProductCodes, planProductIDs)) {
                        if (_tenderTypes) {
                            var _tenderType = _tenderTypes === null || _tenderTypes === void 0 ? void 0 : _tenderTypes.split(',');
                            _tenderType === null || _tenderType === void 0 ? void 0 : _tenderType.forEach(function (type) {
                                var _abpPromo = {
                                    amount: amount && _this.stringToNumber(amount),
                                    id: promotionCode,
                                    name: promo === null || promo === void 0 ? void 0 : promo.description,
                                };
                                if (type &&
                                    (type === null || type === void 0 ? void 0 : type.toLowerCase()) !== 'creditcard' &&
                                    abpPromotions[type.toLowerCase()]) {
                                    abpPromotions[type.toLowerCase()] = _abpPromo;
                                }
                                else if (type &&
                                    (type === null || type === void 0 ? void 0 : type.toLowerCase()) === 'creditcard' &&
                                    _providerTypes &&
                                    (_providerTypes === null || _providerTypes === void 0 ? void 0 : _providerTypes.indexOf('aTTcitiCobranded')) > -1) {
                                    abpPromotions.citicard = _abpPromo;
                                }
                                else if (type &&
                                    (type === null || type === void 0 ? void 0 : type.toLowerCase()) === 'creditcard' &&
                                    _providerTypes &&
                                    (_providerTypes === null || _providerTypes === void 0 ? void 0 : _providerTypes.indexOf('non-citiCobranded')) > -1) {
                                    abpPromotions.creditcard = _abpPromo;
                                }
                            });
                        }
                    }
                });
            }
            else {
                abpPromotions = undefined;
            }
            return abpPromotions;
        };
        this.getCharacteristic = function (data) {
            if (data === void 0) { data = []; }
            var result = {};
            data === null || data === void 0 ? void 0 : data.forEach(function (extension) {
                if (extension === null || extension === void 0 ? void 0 : extension.name) {
                    result[extension.name] = extension.value;
                }
            });
            return result;
        };
        this.validateCatalogAbpResponse = function (resp) {
            if (resp && (resp === null || resp === void 0 ? void 0 : resp.length) > 0) {
                var _abpInfoList_1 = [];
                var filterPromotions = resp.filter(function (promo) { var _a; return (_a = promo === null || promo === void 0 ? void 0 : promo.promotionCharacteristics) === null || _a === void 0 ? void 0 : _a.some(function (type) { return (type === null || type === void 0 ? void 0 : type.name) === 'tenderTypes'; }); });
                filterPromotions === null || filterPromotions === void 0 ? void 0 : filterPromotions.forEach(function (promo) {
                    var abpTypes = _this.getCharacteristic(promo === null || promo === void 0 ? void 0 : promo.promotionCharacteristics);
                    var isUpdated = false;
                    _abpInfoList_1 === null || _abpInfoList_1 === void 0 ? void 0 : _abpInfoList_1.forEach(function (promoL) {
                        var _a;
                        if (abpTypes.amount === promoL.amount) {
                            isUpdated = true;
                            var tenderTypesLst = __spreadArrays(Array.from(new Set(((_a = abpTypes.tenderTypes) === null || _a === void 0 ? void 0 : _a.toLowerCase().split(',')) || [])));
                            promoL.tenderTypes = tenderTypesLst;
                        }
                    });
                    if (!isUpdated) {
                        _abpInfoList_1.push(abpTypes);
                    }
                });
                return _abpInfoList_1.length > 1 ? _abpInfoList_1 : null;
            }
            else {
                return null;
            }
        };
        this.abpPromos = data === null || data === void 0 ? void 0 : data.promotionsOffers;
        this.cartResponse = Utils.getCartResponse();
    }
    AbpPromotionsMapper.prototype.getDataObject = function () {
        return this.abpPromos;
    };
    AbpPromotionsMapper.prototype.getFormattedABPPromotions = function () {
        var _this = this;
        var _a;
        if (this.cartResponse &&
            this.cartResponse.content &&
            this.cartResponse.content.payload &&
            this.cartResponse.content.payload.wirelessCart &&
            this.cartResponse.content.payload.wirelessCart.losgs) {
            var planProductIDs_1 = [];
            var losgs = this.cartResponse.content.payload.wirelessCart.losgs;
            (_a = Object.values(losgs)) === null || _a === void 0 ? void 0 : _a.forEach(function (losg) {
                var _a;
                var items = losg === null || losg === void 0 ? void 0 : losg.lineItems;
                (_a = Object.values(items)) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
                    var planProductIDsData = _this.formatPlanProductIDs(item, planProductIDs_1);
                    planProductIDsData && planProductIDs_1.push(planProductIDsData);
                });
            });
            return this.getABPPromotionsWithTenderTypes(planProductIDs_1, this.abpPromos);
        }
        return null;
    };
    return AbpPromotionsMapper;
}());
exports.AbpPromotionsMapper = AbpPromotionsMapper;
//# sourceMappingURL=AbpPromotionsMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/AbpPromotionsMapper.js
// module id = 2216
// module chunks = 8